import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/layout/Footer';
import { clientsList, testimonials } from '../data/mock';
import { Star } from 'lucide-react';
import { ScrollReveal, StaggerContainer, StaggerItem } from '../components/ui/ScrollReveal';

const ClientsPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF8F2]">
      <motion.main
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="pb-24 pt-24"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {/* Page Heading - compact, matches services/projects/teams */}
          <ScrollReveal variant="fadeUp" threshold={0.2}>
          <div className="mb-10">
            <span className="text-xs tracking-[0.2em] text-[#6B6B65] uppercase">
              Trusted by industry leaders
            </span>
            <h1 className="font-serif text-4xl md:text-5xl text-[#1A1A1A] mt-2 font-semibold">
              Our Clients
            </h1>
          </div>
          </ScrollReveal>

          {/* Clients Grid */}
          <section id="clients-list" className="mb-16">
            <StaggerContainer staggerDelay={0.06} threshold={0.1}>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {clientsList.map((client) => (
                <StaggerItem key={client.id}>
                <div
                  className="group w-full bg-white rounded-xl overflow-hidden border border-[#E0DDD9] hover:border-[#8B7355]/40 hover:shadow-lg hover:shadow-[#8B7355]/5 hover:-translate-y-0.5 transition-all duration-300 p-5"
                >
                  <div className="h-20 mb-3 flex items-center justify-center bg-[#FAFAF9] rounded-lg px-4 py-3 group-hover:bg-[#F5F3F0] transition-colors">
                    <img
                      src={client.logo}
                      alt={client.name}
                      className="max-h-full max-w-full w-auto object-contain"
                    />
                  </div>
                  <h3 className="font-serif text-base text-[#1A1A1A] font-semibold group-hover:text-[#8B7355] mb-1 transition-colors line-clamp-2">
                    {client.name}
                  </h3>
                  <p className="text-xs text-[#8B7355] font-medium mb-2">{client.industry}</p>
                  <p className="text-[#6B6B65] text-xs leading-relaxed line-clamp-2">{client.description}</p>
                </div>
                </StaggerItem>
              ))}
            </div>
            </StaggerContainer>
          </section>

          <hr className="border-t border-[#E0DDD9] my-12" />

          {/* Testimonials */}
          <ScrollReveal variant="fadeUp" threshold={0.15}>
          <section id="testimonials" className="mb-16">
            <div className="text-center mb-8">
              <span className="text-[#8B7355] text-xs font-semibold tracking-[0.2em] uppercase">
                Testimonials
              </span>
              <h2 className="font-serif text-2xl md:text-3xl text-[#1A1A1A] mt-2 font-semibold">
                Client testimonials
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              {testimonials.map((testimonial) => (
                <div
                  key={testimonial.id}
                  className="group w-full bg-white rounded-xl overflow-hidden border border-[#E0DDD9] hover:border-[#8B7355]/40 hover:shadow-lg hover:shadow-[#8B7355]/5 hover:-translate-y-0.5 transition-all duration-300 p-5"
                >
                  <div className="flex gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-[#8B7355] text-[#8B7355]" />
                    ))}
                  </div>
                  <p className="text-[#1A1A1A] leading-relaxed mb-4 text-sm md:text-base">
                    "{testimonial.quote}"
                  </p>
                  <div className="flex items-center gap-3 pt-3 border-t border-[#E0DDD9]/60">
                    <div className="min-w-0">
                      <h4 className="font-medium text-[#1A1A1A] text-sm">{testimonial.name}</h4>
                      <p className="text-xs text-[#8B7355]">{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
          </ScrollReveal>
        </div>
      </motion.main>
      <Footer />
    </div>
  );
};

export default ClientsPage;
